import { nextTick } from "vue";

export default {
  setPdType({commit}, pdType) {
    commit('SET_PD_TYPE', pdType)
  },
  setPdValues({commit, dispatch}, values) {
    if (values.far) {
      if (values.far.left) commit('SET_FAR_LEFT_PD', values.far.left)
      if (values.far.right) commit('SET_FAR_RIGHT_PD', values.far.right)
    }
    if (values.close) {
      if (values.close.left) commit('SET_CLOSE_LEFT_PD', values.close.left)
      if (values.close.right) commit('SET_CLOSE_RIGHT_PD', values.close.right)
    }

    dispatch('updatePd')
  },
  setCloseLeftPd({commit}, value) {
    commit('SET_CLOSE_LEFT_PD', value)
  },
  setCloseRightPd({commit}, value) {
    commit('SET_CLOSE_RIGHT_PD', value)
  },
  setFarLeftPd({commit}, value) {
    commit('SET_FAR_LEFT_PD', value)
  },
  setFarRightPd({commit}, value) {
    commit('SET_FAR_RIGHT_PD', value)
  },
  resetPdData({commit}, data) {
    commit('RESET_PD_DATA', data)
  },
  setCurrentStep({commit}, step) {
    commit('SET_CURRENT_STEP', step)
  },
  setSelection({commit}, {key, value}) {
    commit('SET_SELECTION', {key, value})
  },
  deleteSelection({commit, state}, key) {
    commit('DELETE_SELECTION', key)

    if (state.priceMapping[key]) {
      const priceField = state.priceMapping[key]
      commit('UPDATE_PRICE', {key: priceField, value: 0})
    }
  },
  setQuantity({commit}, quantity) {
    commit('SET_QUANTITY', quantity)
  },
  setRowId({commit}, id) {
    commit('SET_ROW_ID', id)
  },
  setPrescriptionData({commit}, data) {
    commit('SET_PRESCRIPTION_DATA', data)
  },
  setPrescriptionDataSubmitted({commit}, submitted) {
    commit('SET_PRESCRIPTION_DATA_SUBMITTED', submitted)
  },
  setIsAdvancing({commit}, advancing) {
    commit('SET_IS_ADVANCING', advancing)
  },
  setIsGoingBack({commit}, goingBack) {
    commit('SET_IS_GOING_BACK', goingBack)
  },
  setPricingLevel({commit, getters}, level) {
    commit('SET_PRICING_LEVEL', level)
  },
  sortByCustomOrder({state}, {options, step}) {
    const customOrder = [
      'prescription_type',
      'lens_type',
      'lens_quality',
      'thinning',
      'lens_pattern',
      'color'
    ]

    if (customOrder.includes(step)) {
      return options.sort((a, b) => {
        return customOrder.indexOf(a) - customOrder.indexOf(b)
      })
    }
    return options
  },
  isStepSelected({state, getters}, step) {
    if (step === 'prescription_table') {
      if (state.prescriptionDataSubmitted) return true
      return state.selections['prescription_type'] === 'Χωρίς Συνταγή'
    }
    const value = state.selections[step]
    return value !== undefined && value !== null && value !== 'Null'
  },
  isStepSelectable({state, getters}, stepNumber) {
    if (stepNumber <= 0 || stepNumber > getters.steps.length) return false

    for (let i = 1; i < stepNumber; i++) {
      const stepKey = getters.steps[i - 1]
      if (!state.selections[stepKey]) {
        return false
      }
    }

    return true
  },
  scrollToTop({state}) {
    const offset = 300;
    const element = document.querySelector('.prescription-form-wrapper');
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  },
  async safeNextStep({commit, state}) {
    if (state.isAdvancing) return
    commit('SET_IS_ADVANCING', true)
    commit('SET_CURRENT_STEP', state.currentStep + 1)
    await nextTick()
    commit('SET_IS_ADVANCING', false)
  },
  safePreviousStep({state, commit, dispatch, getters}) {
    if (state.currentStep <= 1) {
      return
    }

    const findPreviousValidStep = (currentStepIndex) => {
      if (currentStepIndex <= 1) {
        return 1;
      }

      const previousStepIndex = currentStepIndex - 1;
      const previousStepKey = getters.steps[previousStepIndex - 1]?.key;

      if (!previousStepKey) {
        return 1;
      }

      const stepData = state.stepData[previousStepKey] || [];

      if (stepData.length === 0 || stepData.every(item => item === 'Null')) {
        if (state.selections[previousStepKey]) {
          dispatch('deleteSelection', previousStepKey);
        }
        return findPreviousValidStep(previousStepIndex);
      }

      return previousStepIndex;
    };

    const originalStep = state.currentStep;
    const targetStep = findPreviousValidStep(originalStep);

    for (let i = targetStep + 1; i <= originalStep; i++) {
      const stepKey = getters.steps[i - 1]?.key;
      if (stepKey && state.selections[stepKey]) {
        dispatch('deleteSelection', stepKey);
      }
    }

    commit('SET_IS_GOING_BACK', true);
    commit('SET_IS_ADVANCING', false);
    commit('SET_CURRENT_STEP', targetStep);
    dispatch('updatePricesAfterGoingBack');

    commit('SET_IS_GOING_BACK', false);
  },
  previousStep({commit, state, dispatch, getters}) {
    if (state.currentStep <= 1) return

    commit('SET_IS_GOING_BACK', true)
    let targetStep = state.currentStep - 1

    const currentStepKey = getters.steps[state.currentStep - 1]
    if (currentStepKey && state.selections[currentStepKey]) {
      dispatch('deleteSelection', currentStepKey)
    }
    const hasValidOptions = (stepKey) => {
      if (!stepKey || !state.csv || state.csv.length === 0) return false
      
      // prescription_table is always a valid step (unless "no prescription" was selected)
      if (stepKey === 'prescription_table') {
        return state.selections['prescription_type'] !== 'Χωρίς Συνταγή'
      }

      const selections = {...state.selections}
      // Delete the selection for the step we're checking to avoid circular dependency
      delete selections[stepKey]

      const filtered = state.csv.filter(row =>
        Object.keys(selections).every(key =>
          !Object.prototype.hasOwnProperty.call(row, key) ||
          selections[key] === undefined ||
          row[key] === selections[key]
        )
      )

      // Get unique options for this step
      const options = [...new Set(
        filtered.map(r => r[stepKey]).filter(v => v !== undefined && v !== null && v !== '' && v !== 'Null')
      )]

      return options.length > 0
    }

    // Auto-advance backwards until finding a step with valid options
    while (targetStep > 1) {
      const stepKey = getters.steps[targetStep - 1]
      if (hasValidOptions(stepKey)) {
        break
      }

      if (stepKey && state.selections[stepKey]) {
        dispatch('deleteSelection', stepKey)
      }

      targetStep--
    }

    const targetStepKey = getters.steps[targetStep - 1]
    if (targetStepKey && state.selections[targetStepKey]) {
      dispatch('deleteSelection', targetStepKey)
    }
    
    // Reset prescription data submitted flag when going back to prescription_table
    if (targetStepKey === 'prescription_table') {
      commit('SET_PRESCRIPTION_DATA_SUBMITTED', false)
    }

    commit('SET_CURRENT_STEP', targetStep)
    dispatch('updatePricesAfterGoingBack')
    commit('SET_IS_GOING_BACK', false)
  },
  goToStep({commit, state, getters, dispatch}, stepNumber) {
    if (stepNumber <= 0 || stepNumber > getters.steps.length) return
    commit('SET_IS_GOING_BACK', true)
    const stepsToReset = getters.steps.slice(stepNumber - 1)
    stepsToReset.forEach(step => {
      commit('DELETE_SELECTION', step)
    })

    commit('SET_CURRENT_STEP', stepNumber)
    
    // Reset prescription data submitted flag when going back to prescription_table
    const targetStepKey = getters.steps[stepNumber - 1]
    if (targetStepKey === 'prescription_table') {
      commit('SET_PRESCRIPTION_DATA_SUBMITTED', false)
    }
    
    commit('SET_IS_GOING_BACK', false)
  },
  async handleSelectChange({dispatch, state, getters}) {
    if (state.currentStep === 1 && state.selections['prescription_type'] === 'Χωρίς Συνταγή') {
      dispatch('setPrescriptionDataSubmitted', true);
      const steps = getters.steps;
      const prescriptionTableIndex = steps.indexOf('prescription_table');
      if (prescriptionTableIndex !== -1 && prescriptionTableIndex + 1 < steps.length) {
        dispatch('setCurrentStep', prescriptionTableIndex + 2);
        return;
      }
    }

    const hasMatchingRows = state.csv.some(row => {
      return Object.entries(state.selections).every(([key, value]) => {
        if (value === undefined || value === null || value === 'Null' || key === 'prescription_table') {
          return true;
        }
        return row[key] === value;
      });
    });

    if (!hasMatchingRows) {
      return;
    }

    const nextStep = state.currentStep + 1
    if (nextStep <= getters.steps.length) {
      const nextStepKey = getters.steps[nextStep - 1]
      const nextStepOptions = await dispatch('availableOptions', nextStepKey)

      if (Array.isArray(nextStepOptions) && nextStepOptions.length > 0) {
        await dispatch('safeNextStep')
      }
    } else {
      await dispatch('safeNextStep')
    }
  },
  async autoAdvance({state, getters, commit, dispatch}) {
    const currentStepKey = getters.currentStepKey
    if (!currentStepKey) return
    
    // Don't auto-advance if current step already has a real selection
    const currentSelection = state.selections[currentStepKey]
    if (currentSelection !== undefined && currentSelection !== null && currentSelection !== 'Null') {
      return
    }
    
    await nextTick()
    if (
      currentStepKey === 'prescription_table' &&
      state.selections['prescription_type'] === 'Χωρίς Συνταγή'
    ) {
      commit('SET_PRESCRIPTION_DATA_SUBMITTED', true)
      dispatch('safeNextStep')
      return
    }

    if (currentStepKey === 'prescription_table') {
      commit('SET_PRESCRIPTION_DATA_SUBMITTED', false)
      return
    }

    // Check if the current selections match any rows in the CSV
    const hasMatchingRows = state.csv.some(row => {
      return Object.entries(state.selections).every(([key, value]) => {
        // Skip undefined selections or prescription_table
        if (value === undefined || value === null || value === 'Null' || key === 'prescription_table') {
          return true;
        }
        return row[key] === value;
      });
    });

    // If no matching rows for current selections, don't auto-advance
    if (!hasMatchingRows) {
      return;
    }

    const options = await dispatch('availableOptions', currentStepKey)

    // Don't auto-advance if no options are available (empty array)
    if (!Array.isArray(options) || options.length === 0) {
      return
    }

    // Only auto-skip steps with Null values, but don't recursively advance
    // This prevents skipping steps with actual choices
    if (Array.isArray(options) && options.length === 1 &&
      (options[0] === null || options[0] === 'Null') &&
      state.currentStep !== 2) {
      commit('SET_SELECTION', {key: currentStepKey, value: 'Null'})
      await nextTick()
      dispatch('safeNextStep')
      // Removed recursive autoAdvance call to prevent skipping multiple steps
    }
  },
  async availableOptions({state, getters, commit, dispatch}, step) {
    const filtered = getters.filteredRows
    if (!Array.isArray(filtered)) {
      return []
    }

    if (state.currentStep === 2 && state.selections['prescription_type'] === 'Χωρίς Συνταγή') {
      commit('SET_PRESCRIPTION_DATA_SUBMITTED', true)
    }

    if (state.currentStep === 3 && state.selections.level === undefined) {
      const level = getters.pricingLevel.toString()
      commit('SET_SELECTION', {key: 'level', value: level})
    }

    if (step === 'prescription_table') {
      const opts = [...new Set(filtered.map(r => r[step]))]
      const finalOpts = opts.length ? opts : ['Null']
      return dispatch('sortByCustomOrder', { options: finalOpts, step })
    } else {
      const strictFiltered = filtered.filter(row => {
        return Object.entries(state.selections).every(([selStep, selValue]) => {
          if (selStep === 'prescription_table') return true
          if (selValue === undefined || selValue === null || selValue === 'Null') return true
          return row[selStep] === selValue
        })
      })

      if (strictFiltered.length === 0) {
        return []
      }

      const opts = [...new Set(strictFiltered.map(r => r[step]))]
      const finalOpts = opts.length ? opts : ['Null']
      return dispatch('sortByCustomOrder', { options: finalOpts, step })
    }
  },
  finalStepHandler({state, getters, dispatch}) {
    if (state.currentStep > getters.steps.length) {
      dispatch('updateFinalState')
    }
  },
  stepExtras({state, commit, getters}, stepNumber) {
    if (stepNumber === 1) {
      commit('SET_SELECTION', {key: 'level', value: undefined})
      commit('SET_PRESCRIPTION_DATA_SUBMITTED', true)
    }

    if (stepNumber === 2) {
      commit('SET_SELECTION', {key: 'level', value: undefined})
      commit('SET_PRESCRIPTION_DATA_SUBMITTED', false)
    }

    const stepIndex = getters.steps.indexOf('prescription_table')
    if (stepNumber <= stepIndex && stepIndex !== -1) {
      commit('SET_PRESCRIPTION_DATA_SUBMITTED', false)
    }
  },
  handlePrescription({commit, dispatch}, data) {
    commit('SET_PRESCRIPTION_DATA', data)
    commit('SET_PRESCRIPTION_DATA_SUBMITTED', true)
    dispatch('safeNextStep')
  },
  setPrices({commit}, prices) {
    commit('SET_PRICES', prices)
  },
  updatePrice({commit}, {key, value}) {
    commit('UPDATE_PRICE', {key, value})
  },
  setCsv({commit}, csv) {
    commit('SET_CSV', csv)
  },
  setSteps({commit, getters}) {
    const steps = getters.steps
    commit('SET_STEPS', steps)
  },
  setProductData({commit}, productData) {
    commit('SET_PRODUCT_DATA', productData)
  },
  updatePricesBasedOnRowId({commit, state, getters}, rowId) {
    const selectedItem = state.csv.find(item => item.id === rowId)
    if (selectedItem) {
      const prices = {}
      Object.keys(getters.priceMapping).forEach(key => {
        const priceField = getters.priceMapping[key]
        if (selectedItem[priceField]) {
          prices[priceField] = parseFloat(selectedItem[priceField])
        }
      })
      commit('SET_PRICES', prices)
      commit('SET_ROW_ID', rowId)
    }
  },
  /**
   * Determines the pricing level based on prescription data from both eyes.
   * @returns {number} Pricing level (1, 2, or 3).
   */
  getLevel({state}) {
    if (!state.prescriptionData || Object.keys(state.prescriptionData).length === 0) {
      console.warn('No prescription data, returning level 1');
      return 1;
    }

    const {close, far} = state.prescriptionData;

    const eyes = ['left', 'right'];
    let maxCylValue = 0;
    let maxSphValue = 0;

    if (!close || !far) {
      console.warn('Missing close or far data, returning level 1');
      return 1;
    }

    eyes.forEach(eye => {
      const closeEyeData = close[eye];
      const farEyeData = far[eye];

      if (closeEyeData) {
        const cyl = parseFloat(closeEyeData.cyl) || 0;
        const sph = parseFloat(closeEyeData.sph) || 0;
        maxCylValue = Math.max(maxCylValue, Math.abs(cyl));
        maxSphValue = Math.max(maxSphValue, Math.abs(sph));
      }

      if (farEyeData) {
        const cyl = parseFloat(farEyeData.cyl) || 0;
        const sph = parseFloat(farEyeData.sph) || 0;
        maxCylValue = Math.max(maxCylValue, Math.abs(cyl));
        maxSphValue = Math.max(maxSphValue, Math.abs(sph));
      }
    });

    if (maxCylValue >= 4.25 || maxSphValue >= 10) {
      return 3;
    }

    if (
      (maxCylValue >= 2.25 && maxCylValue < 4.25) ||
      (maxSphValue >= 6 && maxSphValue < 10)
    ) {
      return 2;
    }

    return 1;
  },
  findMatchingId({state, getters, commit, dispatch}) {
    const expectedKeys = [
      'color',
      'filter',
      'lens_pattern',
      'lens_quality',
      'lens_type',
      'level',
      'prescription_type',
      'thinning'
    ]
    const matchingItem = state.csv.find((item) => {
      return expectedKeys.every(key => {
        const selectionValue = state.selections[key]?.value || state.selections[key]
        const itemValue = item[key]

        if (selectionValue === undefined || itemValue === undefined) {
          console.warn(`Skipping comparison for key ${key} due to undefined value`)
          return false
        }

        const normalizedSelection = String(selectionValue).trim().toLowerCase()
        const normalizedItem = String(itemValue).trim().toLowerCase()

        return normalizedSelection === normalizedItem
      })
    })

    return matchingItem ? matchingItem.id : null
  },
  async updateFinalState({dispatch}) {
    const rowId = await dispatch('findMatchingId')
    if (rowId) {
      dispatch('updatePricesBasedOnRowId', rowId)
    }
    dispatch('updatePd')
  },
  async handleButtonClick({state, getters, dispatch, commit, rootGetters}) {
    const firstKey = Object.keys(state.productData.productStocks)[0];
    const productCodeId = state.productData.productStocks[firstKey].product_code_id;
    let prescriptionPrice = 0;

    const level = getters.pricingLevel;

    if (state.selections.level !== level.toString()) {
      await dispatch('setSelection', {key: 'level', value: level.toString()});
    }

    let rowId = state.rowId;
    if (!rowId) {
      rowId = await dispatch('findMatchingId');
      if (rowId) {
        commit('SET_ROW_ID', rowId);
      } else {
        console.warn('Could not find a matching rowId for the current selections');
      }
    }

    if (rowId && state.csv && state.csv.length && state.productData) {
      const selectedItem = state.csv.find(item => item.id === rowId);

      if (selectedItem) {
        prescriptionPrice = ['price_1', 'price_2', 'price_3', 'price_4'].reduce((total, priceField) => {
          return total + parseFloat(selectedItem[priceField] || 0);
        }, 0);

        prescriptionPrice = parseFloat(prescriptionPrice.toFixed(2));
      }
    }

    let finalQuantity = 1;
    let existingItem = null;

    if (rootGetters.cartContents && rowId) {
      existingItem = rootGetters.cartContents.find(item =>
        item.options.rowId === rowId
      );

      if (existingItem) {
        finalQuantity = existingItem.quantity + 1;
      }
    }

    commit('SET_QUANTITY', finalQuantity);

    const cartPayload = {
      productCodeId: productCodeId,
      quantity: finalQuantity,
      options: {
        rowId: rowId,
        prescription: state.selections,
        prescriptionData: state.prescriptionData,
        prescriptionPrice: prescriptionPrice
      }
    };

    // Always use addToCartClicked with the new quantity
    dispatch('addToCartClicked', cartPayload, {root: true});
  },
  updatePd({state, commit}) {
    const pdData = {
      pdType: state.pdType
    }

    if (state.pdType === 'one') {
      pdData.pd = {
        close: {
          pd: state.close.left.pd
        },
        far: {
          pd: state.far.left.pd
        }
      }
    } else {
      pdData.pd = {
        close: {
          left: state.close.left.pd,
          right: state.close.right.pd
        },
        far: {
          left: state.far.left.pd,
          right: state.far.right.pd
        }
      }
    }
    commit('SET_PD_DATA', pdData)
    return pdData
  },
  updatePricesAfterGoingBack({state, commit}) {
    if (!state.csv || state.csv.length === 0) return;

    const priceFields = ['price_1', 'price_2', 'price_3', 'price_4'];
    const prices = {};

    const matchingItem = state.csv.find(item =>
      Object.keys(state.selections).every(key =>
        state.selections[key] === undefined ||
        state.selections[key] === null ||
        item[key] === state.selections[key]
      )
    );

    if (matchingItem) {
      if (matchingItem.id) {
        commit('SET_ROW_ID', matchingItem.id);
      }

      Object.keys(state.priceMapping).forEach(key => {
        const priceField = state.priceMapping[key];
        if (priceField && priceFields.includes(priceField)) {
          if (state.selections[key]) {
            prices[priceField] = parseFloat(matchingItem[priceField] || 0).toFixed(2);
          } else {
            prices[priceField] = 0;
          }
        }
      });

      commit('SET_PRICES', prices);
    }
  },
}
